export enum StoreKeys {
  ACCESS_TOKEN_KEY = 'accessToken',
  REFRESH_TOKEN_KEY = 'refreshToken',
  TOKEN_EXPIRY = 'tokenExpiry',
  USER_KEY = 'user',
  FILTERS = 'filters',
  ENV_CONFIG = 'envConfig',
  LAST_ACCESSED_URL = 'lastAccessedUrl',
  Delivery_Managers = 'deliveryManagers',
}
